import Image from "next/image"
import { BASE_PATH } from "@/constants/app.mjs"

const logoList = [
  "logo-aave.svg",
  "logo-morpho.svg",
  "logo-pendle.svg",
  "logo-orca.svg",
  "logo-raydium.svg",
  "logo-etherfi.svg",
  "logo-neutrl.svg",
  "logo-layerzero.svg",
  "logo-euler.svg",
  "logo-superstate.svg",
  "logo-eigenlayer.svg",
  "logo-fluid.svg",
  "logo-dolomite.svg",
  "logo-usual.svg",
  "logo-wormhole.svg",
]

const AppPartnerGrid = () => {
  const logos = logoList.slice(0, 15)

  return (
    <div
      className="flex flex-col gap-2 items-center py-16 animate-fade-in-up"
      style={{
        opacity: 0,
        animationDelay: "0.5s",
      }}
    >
      <div className="text-fg-secondary text-center px-10x mb-4x lg:mb-6x">
        Trusted by 100+ apps across DeFi, RWA, and beyond
      </div>
      <div className="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 items-center justify-center justify-items-center invert dark:invert-0">
        {logos.map((logo) => (
          <Image
            key={logo}
            className="w-full h-[100px] px-8 py-5 object-contain"
            alt={logo}
            src={`${BASE_PATH}/static/images/marketing/app-partnership/logos/${logo}`}
            width={520}
            height={500}
          />
        ))}
      </div>
    </div>
  )
}

export default AppPartnerGrid
